<template>
  <v-footer
    id="dashboard-core-footer"
    color="#111820"
    class="pa-md-0"
  >


      <v-row
        justify="center"
        align="center"
        class="pa-md-0"
      >
        <v-col
          v-for="(data, i) in footer_data"
          :key="i"
          class="text-center mb-sm-0"
          cols="auto"
        >
          <modal-button
          :tutorial="data.tutorial"
          :label="data.text"
          /> 

        </v-col>
      </v-row>
  </v-footer>
</template>

<script>
  import ModalButton from '@/views/dashboard/pages/home/ModalButton'

  export default {
  components: {
      ModalButton
  },

    name: 'DashboardCoreFooter',

    data: () => ({

      footer_data : [
        {
          tutorial: 'terms',
          text: "Términos y Condiciones",
        },
        {
          tutorial: 'politics',
          text: "Política de Privacidad",
        },

      ]

      // tuto_terms: 
      //   {
      //     tutorial: 'terms',
      //     text: "Términos y Condiciones",
      //   },
      // tuto_politics : 
      //   {
      //     tutorial: 'politics',
      //     text: "Política de Privacidad",
      //   },
      
    }),
  }
</script>


